import React from 'react'
import PropTypes from 'prop-types'
import className from 'classnames'
import {
  MdEmail,
  MdSms,
  MdVideoCall,
  MdRoom,
  MdPhoneIphone
} from 'react-icons/md'
import { IoLogoWhatsapp } from 'react-icons/io'
import types from './types'
import Text from '../Text/Text'
import styles from './typeInteration.module.scss'

const renderContent = (type, active) => {
  const iconStyles = className(styles.icon, {
    [styles.active]: active
  })

  switch (type) {
    case types.TELEPHONE: {
      return (
        <>
          <div className={iconStyles}>
            <MdPhoneIphone color={active ? '#fff' : '#737373'} />
          </div>
          <span>Telefone</span>
        </>
      )
    }
    case types.EMAIL: {
      return (
        <>
          <div className={iconStyles}>
            <MdEmail color={active ? '#fff' : '#737373'} />
          </div>
          <span>E-mail</span>
        </>
      )
    }
    case types.WHATSAPP: {
      return (
        <>
          <div className={iconStyles}>
            <IoLogoWhatsapp color={active ? '#fff' : '#737373'} />
          </div>
          <span>Whatsapp</span>
        </>
      )
    }
    case types.SMS: {
      return (
        <>
          <div className={iconStyles}>
            <MdSms color={active ? '#fff' : '#737373'} />
          </div>
          <span>SMS</span>
        </>
      )
    }
    case types.VIDEO_CONFERENCE: {
      return (
        <>
          <div className={iconStyles}>
            <MdVideoCall color={active ? '#fff' : '#737373'} />
          </div>
          <Text
            size="xxs"
            color="gray"
            font="custom"
            lineHeight="18px"
            margin="5px 0px 0px 0px"
          >
            Videocall
          </Text>
        </>
      )
    }
    default: {
      return (
        <>
          <div className={iconStyles}>
            <MdRoom color={active ? '#fff' : '#737373'} />
          </div>
          <Text
            size="xxs"
            color="gray"
            font="custom"
            lineHeight="18px"
            margin="5px 0px 0px 0px"
          >
            Visita
          </Text>
        </>
      )
    }
  }
}

const TypeInteration = (props) => {
  const { type, active, onClick } = props

  const containerClasses = className(styles.type, {
    [styles.active]: active
  })

  return (
    <div onClick={onClick} className={containerClasses}>
      {renderContent(type, active)}
    </div>
  )
}

TypeInteration.defaultProps = {
  type: types.VISIT,
  active: false,
  onClick: null
}

TypeInteration.propTypes = {
  type: PropTypes.oneOf(Object.values(types)),
  active: PropTypes.bool,
  onClick: PropTypes.func
}

export default TypeInteration
